<template>
  <v-app id="inspire">
    <Navbar v-if="isLoggedIn" />
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

import {mapActions, mapGetters} from 'vuex'
import Navbar from './components/Navbar.vue'

export default {
  name: 'App',
  components: {
    Navbar
  },
  computed: {
    ...mapGetters('user', ["isLoggedIn"]),
  },
  methods: {
    ...mapActions('user', ["logout"]),
    ...mapActions('terminals', ['refetchTerminals']),
    logoutMethod() {
      this.logout().then(() => {
        this.$router.push("/login");
      });
    },
  },
  watch: {
    isLoggedIn: {
      handler(val) {
        if (!val) return
        
        this.refetchTerminals();
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss">
  @media screen and (max-width: 768px) {
    .v-slide-group__prev,
    .v-slide-group__next {
      display: none !important;
    }
  }

</style>